import { render, staticRenderFns } from "./MainHead.vue?vue&type=template&id=54a847cf&scoped=true&"
import script from "./MainHead.vue?vue&type=script&lang=js&"
export * from "./MainHead.vue?vue&type=script&lang=js&"
import style0 from "./MainHead.vue?vue&type=style&index=0&id=54a847cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a847cf",
  null
  
)

export default component.exports